import type { FunctionComponent } from 'react'
import React from 'react'
import { Typography } from '@which/seatbelt'
import type { TypographyTokenNames } from '@which/seatbelt/build/src/components/Seatbelt2/Foundations/Typography/Typography'

import classnames from 'classnames'

import { getKindeRedirectUrl } from '../../../utils/get-kinde-redirect-url'
import { sendLogoutRequest } from '../../../utils/send-logout-request'
import { Link } from '../../Link'

type Props = {
  textStyle?: TypographyTokenNames
  className?: string
  email: string
}

export const NewsletterLoggedInUserText: FunctionComponent<Props> = ({
  email,
  className,
  textStyle = 'sb-text-interface-body-default-regular',
}) => {
  const handleLogout = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault()
    sendLogoutRequest(getKindeRedirectUrl())
  }

  return (
    <Typography
      textStyle={textStyle}
      className={classnames(className)}
      dataTestId="logged-in-user-text"
    >
      Logged in as <b which-pii="true">{email}</b>. Not you?{' '}
      <Link href={getKindeRedirectUrl()} onClick={handleLogout}>
        Log out
      </Link>
    </Typography>
  )
}
